function DO() {
  return (
    <div>
      <li className="bullet-item">
        The top level concepts from the{' '}
        <a className="tt" target="_blank" rel="noreferrer" href="http://disease-ontology.org/">
          Human Disease Ontology
        </a>
      </li>
    </div>
  );
}

export default DO;
